import React, { useState } from "react";
import "./HealthTwoCustomerReviews.scss";
import AddTestimonials from "../../../../default-hooks/addTestimonials";
import UpdateTestimonial from "../../../../default-hooks/UpdateTestimonial";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";
import { useFirestore } from "../../../../firebase-files/hooks/useFirestore";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const HealthTwoCustomerReviews = () => {
  const { user } = useAuthContext();
  const { documents: reviews } = useCollection("testimonials");
  const { documents: users } = useCollection("users");
  const { deleteDocument } = useFirestore("testimonials");

  const [startIndex, setStartIndex] = useState(0);
  const [editingTestimonial, setEditingTestimonial] = useState(null);
  const itemsPerPage = 3;

  const isAdmin = user && user.role === "admin";

  const visibleReviews = reviews
    ? reviews.filter((review) =>
        isAdmin ? true : review.status === "active"
      )
    : [];

  const paginatedReviews = visibleReviews.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handleNext = () => {
    if (!visibleReviews) return;
    const count = visibleReviews.length;
    setStartIndex((prev) =>
      prev + itemsPerPage >= count ? 0 : prev + itemsPerPage
    );
  };

  const getReviewerName = (createdBy) => {
    if (!users || !createdBy) return "Anonymous";
    const match = users.find((u) => u.phoneNumber === createdBy);
    return match ? match.fullName : "Anonymous";
  };

  const handleDelete = async (id) => {
    await deleteDocument(id);
  };

  return (
    <section className="health-two-customer-reviews">
      <div className="reviews-wrapper">
        <div className="health-two-section-heading">
          <h2>What our Customers say</h2>
          <span className="next" onClick={handleNext}>
            SEE ALL REVIEWS →
          </span>
        </div>

        <div className="review-cards">
          {paginatedReviews.length > 0 ? (
            paginatedReviews.map((review, index) => {
              const canEdit = user && user.role === "admin";
              const canDelete = user && user.role === "admin";

              return (
                <div className="review-card" key={index}>
                  {(canEdit || canDelete) && (
                    <div className="review-actions">
                      {canEdit && (
                        <EditIcon
                          className="edit-icon"
                          onClick={() =>
                            setEditingTestimonial({ ...review, id: review.id })
                          }
                        />
                      )}
                      {canDelete && (
                        <DeleteIcon
                          className="delete-icon"
                          onClick={() => handleDelete(review.id)}
                        />
                      )}
                    </div>
                  )}

                  <div className="review-content">
                    {review.title && <h4>{review.title}</h4>}
                    <p>“{review.description || "No description provided"}”</p>
                  </div>

                  <div className="review-footer">
                    <h5>{getReviewerName(review.createdBy)}</h5>
                    <Rating
                      name={`read-only-rating-${index}`}
                      value={parseFloat(review.rating) || 0}
                      precision={0.5}
                      readOnly
                      size="small"
                      emptyIcon={
                        <StarIcon style={{ opacity: 0.4 }} fontSize="inherit" />
                      }
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <p>No customer reviews available yet.</p>
          )}
        </div>

        {editingTestimonial && (
          <UpdateTestimonial
            testimonial={editingTestimonial}
            onClose={() => setEditingTestimonial(null)}
          />
        )}

        {user && <AddTestimonials />}
      </div>
    </section>
  );
};

export default HealthTwoCustomerReviews;
